// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/LibreFranklin-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/LibreFranklin-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "LibreFranklin-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "LibreFranklin-ExtraBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

body {
  background-color: #2c2c2c !important;
  font-family: "LibreFranklin-Regular", sans-serif !important;
}

.fixed-height-card {
  height: 300px;
}

body.light-theme .active-color {
  color: #b31e8d;
}

body.dark-theme .active-color {
  color: #fff;
}

.App-link {
  color: #61dafb;
}

.nav-icon-color {
  color: #000; /* or desired default */
  transition: 0.2s ease;
}
.nav-icon-color:hover {
  color: #263f86;
}

.bottom-nav-mobile a {
  font-size: 1.2rem;
  padding: 6px;
}
.bottom-nav-mobile i {
  display: block;
}

.mobile-nav-active {
  border-top: 2px solid #b31e8d; /* Bootstrap primary or any color */
  color: #b31e8d !important;
}

.status-active {
  background-color: #76d7c4;
  color: #282c34 !important;
}

.status-pending {
  background-color: #f9e79f;
  color: #282c34 !important;
}

.status-incomplete {
  background-color: #f5b7b1;
  color: #282c34 !important;
}

.appraisal-container {
  background-color: #f8f9fa;
  padding: 30px;
  border-radius: 10px;
}

body.light-theme .header-title {
  padding-bottom: 4px;
  color: #b31e8d;
}

body.dark-theme .header-title {
  padding-bottom: 4px;
  color: #ffffff;
}

.excel-button {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #229954;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.5),
    inset 0 -2px 4px rgba(255, 255, 255, 0.05);
  cursor: pointer;
}

.details-button {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #e74c3c;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.5),
    inset 0 -2px 4px rgba(255, 255, 255, 0.05);
  cursor: pointer;
}

.normal-button {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #fff;
  border: none;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.5),
    inset 0 -2px 4px rgba(255, 255, 255, 0.05);
  cursor: pointer;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.pill-dashboard {
  display: flex;
  align-items: center;
  background-color: #525151;
  border-radius: 9999px;
  padding: 8px 16px;
  gap: 10px;
  min-width: 140px;
  justify-content: flex-start;
  flex: 1 1;
}

.pill-circle {
  background-color: #f2d092;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pill-text {
  display: flex;
  align-items: baseline;
  gap: 6px;
  font-size: 16px;
  color: #fff;
  font-weight: 500;
}

.pill-number {
  font-size: 20px;
  font-weight: bold;
  color: #ffa726;
}

.pill-label {
  font-size: 12px;
  color: #fff;
}

.spinner {
  border: 4px solid #444;
  border-top: 4px solid #5d5fef;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.line {
  width: 200px;
  height: 2px;
  background-color: #d63384;
}

.line-light {
  background-color: #d63384;
}

.line-dark {
  background-color: #666;
}

.dropdown-dark .dropdown-item {
  color: #fff;
  background-color: #2c2c2c;
}

.dropdown-dark .dropdown-item:hover,
.dropdown-dark .dropdown-item:focus {
  background-color: #444;
  color: #fff;
}

.custom-btn {
  min-width: 120px;
}

body.light-theme .login-container {
  width: 100%;
  max-width: 400px;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-family: "RobotoFlex";
  background-color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

body.dark-theme .login-container {
  width: 100%;
  max-width: 400px;
  padding: 20px;
  border: 1px solid #222121;
  border-radius: 8px;
  font-family: "RobotoFlex";
  background-color: rgb(61, 61, 61);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

h2 {
  margin-bottom: 0.2rem;
}

p {
  margin-top: 0;
  font-size: 14px;
}

.login-form input[type="text"],
.login-form input[type="password"] {
  display: block;
  width: 100%;
  padding: 12px;
  margin-bottom: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.checkbox-container {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.checkbox-container input {
  margin-right: 8px;
}

.sign-in-button {
  width: 100%;
  padding: 12px;
  background-color: #b31e8d;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
  margin-bottom: 12px;
}

.tracking-timeline {
  position: relative;
  margin-left: 15px;
  padding-left: 0;
}

.tracking-item {
  position: relative;
  padding-left: 30px;
  margin-bottom: 30px;
}

.tracking-item::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 10px; /* center of the dot */
  width: 2px;
  background-color: #ccc;
  z-index: 0;
}

.icon-dot {
  position: absolute;
  left: 5px;
  top: 0;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #28a745;
  z-index: 1;
}

.icon-dot.faded {
  background-color: #bbb;
}

.timestamp {
  font-size: 13px;
  margin-bottom: 3px;
}

.message {
  font-size: 14px;
  line-height: 1.4;
}

.readonly-textarea {
  background-color: #f8f9fa;
  cursor: not-allowed;
  color: #6c757d;
}

.signature-container {
  text-align: center;
  margin: 30px auto;
  max-width: 600px;
}

.signature-canvas {
  border: 2px solid #000;
  border-radius: 4px;
}

/* --------------------------------  */
@media (max-width: 768px) {
  .navbar-brand span {
    display: none;
  }

  .nav-link {
    padding: 0.5rem 0 !important;
  }

  .mobile-text-title {
    font-size: 14px;
  }

  .mobile-table-header {
    font-size: 12px;
  }

  .mobile-text {
    font-size: 12px;
  }

  .mobile-heading {
    width: 160px !important;
  }
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,+DAA8D;EAC9D,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,+DAAgE;EAChE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,2DAA2D;AAC7D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW,EAAE,uBAAuB;EACpC,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B,EAAE,mCAAmC;EAClE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB;8CAC4C;EAC5C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB;8CAC4C;EAC5C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB;8CAC4C;EAC5C,eAAe;AACjB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,2BAA2B;EAC3B,SAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU,EAAE,sBAAsB;EAClC,UAAU;EACV,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE;IACE,aAAa;EACf;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["@font-face {\n  font-family: \"LibreFranklin-Regular\";\n  src: url(\"fonts/LibreFranklin-Regular.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"LibreFranklin-ExtraBold\";\n  src: url(\"fonts/LibreFranklin-ExtraBold.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\nbody {\n  background-color: #2c2c2c !important;\n  font-family: \"LibreFranklin-Regular\", sans-serif !important;\n}\n\n.fixed-height-card {\n  height: 300px;\n}\n\nbody.light-theme .active-color {\n  color: #b31e8d;\n}\n\nbody.dark-theme .active-color {\n  color: #fff;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n.nav-icon-color {\n  color: #000; /* or desired default */\n  transition: 0.2s ease;\n}\n.nav-icon-color:hover {\n  color: #263f86;\n}\n\n.bottom-nav-mobile a {\n  font-size: 1.2rem;\n  padding: 6px;\n}\n.bottom-nav-mobile i {\n  display: block;\n}\n\n.mobile-nav-active {\n  border-top: 2px solid #b31e8d; /* Bootstrap primary or any color */\n  color: #b31e8d !important;\n}\n\n.status-active {\n  background-color: #76d7c4;\n  color: #282c34 !important;\n}\n\n.status-pending {\n  background-color: #f9e79f;\n  color: #282c34 !important;\n}\n\n.status-incomplete {\n  background-color: #f5b7b1;\n  color: #282c34 !important;\n}\n\n.appraisal-container {\n  background-color: #f8f9fa;\n  padding: 30px;\n  border-radius: 10px;\n}\n\nbody.light-theme .header-title {\n  padding-bottom: 4px;\n  color: #b31e8d;\n}\n\nbody.dark-theme .header-title {\n  padding-bottom: 4px;\n  color: #ffffff;\n}\n\n.excel-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #229954;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  padding: 8px 12px;\n  font-size: 14px;\n  font-weight: 500;\n  box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.5),\n    inset 0 -2px 4px rgba(255, 255, 255, 0.05);\n  cursor: pointer;\n}\n\n.details-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #e74c3c;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  padding: 8px 12px;\n  font-size: 14px;\n  font-weight: 500;\n  box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.5),\n    inset 0 -2px 4px rgba(255, 255, 255, 0.05);\n  cursor: pointer;\n}\n\n.normal-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #fff;\n  border: none;\n  border-radius: 6px;\n  padding: 8px 12px;\n  font-size: 14px;\n  font-weight: 500;\n  box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.5),\n    inset 0 -2px 4px rgba(255, 255, 255, 0.05);\n  cursor: pointer;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.pill-dashboard {\n  display: flex;\n  align-items: center;\n  background-color: #525151;\n  border-radius: 9999px;\n  padding: 8px 16px;\n  gap: 10px;\n  min-width: 140px;\n  justify-content: flex-start;\n  flex: 1;\n}\n\n.pill-circle {\n  background-color: #f2d092;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pill-text {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n  font-size: 16px;\n  color: #fff;\n  font-weight: 500;\n}\n\n.pill-number {\n  font-size: 20px;\n  font-weight: bold;\n  color: #ffa726;\n}\n\n.pill-label {\n  font-size: 12px;\n  color: #fff;\n}\n\n.spinner {\n  border: 4px solid #444;\n  border-top: 4px solid #5d5fef;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.line {\n  width: 200px;\n  height: 2px;\n  background-color: #d63384;\n}\n\n.line-light {\n  background-color: #d63384;\n}\n\n.line-dark {\n  background-color: #666;\n}\n\n.dropdown-dark .dropdown-item {\n  color: #fff;\n  background-color: #2c2c2c;\n}\n\n.dropdown-dark .dropdown-item:hover,\n.dropdown-dark .dropdown-item:focus {\n  background-color: #444;\n  color: #fff;\n}\n\n.custom-btn {\n  min-width: 120px;\n}\n\nbody.light-theme .login-container {\n  width: 100%;\n  max-width: 400px;\n  padding: 20px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  font-family: \"RobotoFlex\";\n  background-color: white;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\nbody.dark-theme .login-container {\n  width: 100%;\n  max-width: 400px;\n  padding: 20px;\n  border: 1px solid #222121;\n  border-radius: 8px;\n  font-family: \"RobotoFlex\";\n  background-color: rgb(61, 61, 61);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\nh2 {\n  margin-bottom: 0.2rem;\n}\n\np {\n  margin-top: 0;\n  font-size: 14px;\n}\n\n.login-form input[type=\"text\"],\n.login-form input[type=\"password\"] {\n  display: block;\n  width: 100%;\n  padding: 12px;\n  margin-bottom: 12px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.checkbox-container {\n  display: flex;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.checkbox-container input {\n  margin-right: 8px;\n}\n\n.sign-in-button {\n  width: 100%;\n  padding: 12px;\n  background-color: #b31e8d;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-weight: bold;\n  cursor: pointer;\n  margin-bottom: 12px;\n}\n\n.tracking-timeline {\n  position: relative;\n  margin-left: 15px;\n  padding-left: 0;\n}\n\n.tracking-item {\n  position: relative;\n  padding-left: 30px;\n  margin-bottom: 30px;\n}\n\n.tracking-item::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 10px; /* center of the dot */\n  width: 2px;\n  background-color: #ccc;\n  z-index: 0;\n}\n\n.icon-dot {\n  position: absolute;\n  left: 5px;\n  top: 0;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background-color: #28a745;\n  z-index: 1;\n}\n\n.icon-dot.faded {\n  background-color: #bbb;\n}\n\n.timestamp {\n  font-size: 13px;\n  margin-bottom: 3px;\n}\n\n.message {\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.readonly-textarea {\n  background-color: #f8f9fa;\n  cursor: not-allowed;\n  color: #6c757d;\n}\n\n.signature-container {\n  text-align: center;\n  margin: 30px auto;\n  max-width: 600px;\n}\n\n.signature-canvas {\n  border: 2px solid #000;\n  border-radius: 4px;\n}\n\n/* --------------------------------  */\n@media (max-width: 768px) {\n  .navbar-brand span {\n    display: none;\n  }\n\n  .nav-link {\n    padding: 0.5rem 0 !important;\n  }\n\n  .mobile-text-title {\n    font-size: 14px;\n  }\n\n  .mobile-table-header {\n    font-size: 12px;\n  }\n\n  .mobile-text {\n    font-size: 12px;\n  }\n\n  .mobile-heading {\n    width: 160px !important;\n  }\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
